<template>
  <v-layout column>
    <v-flex xs12>
      <h3>Account Invoice Policies</h3>
    </v-flex>
    <v-layout pt-2 class="search-fields" column>
      <form v-on:keyup.enter="search">
        <v-checkbox v-model="query.enabledOnly" label="Enabled Only"></v-checkbox>
        <v-btn
          @click="createInvoicePolicy"
          color="blue"
          dark
          class="text-none"
        >Create Invoice Policy</v-btn>
      </form>
    </v-layout>
  </v-layout>
</template>

<script>
export default {
  name: "invoice_policy_action_box",
  props: {
    query: Object
  },
  data: function() {
    return {};
  },
  methods: {
    createInvoicePolicy: function() {
      this.$emit("createInvoicePolicy", null);
    }
  },
  components: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.search-fields {
  padding-left: 6px;
  padding-right: 6px;
}
</style>
